import axios, { AxiosResponse } from "axios";

const ValidateCodeAPI = async (code: string): Promise<boolean> => {
  try {
    // Lokalno (development)
    // const url = `http://localhost:6002/api/ultra/politehnika/validate-code/${code.toUpperCase()}`;
    
    // Produkcija
    const url = `https://politehnika-back.firebird.rs/api/ultra/politehnika/validate-code/${code.toUpperCase()}`;
    
    const response: AxiosResponse = await axios.get(url);

    // Backend response format:
    // {
    //   "code": 200,
    //   "message": "OK",
    //   "description": "Kod je validan",
    //   "data": {
    //     "isValid": true,
    //     "code": "3U5V2K6Q"
    //   }
    // }
    
    return response.data.data.isValid; // isValid je u data.data objektu
  } catch (error) {
    console.error("Validate Code API Error:", error);
    return false; // Ako API nije dostupan ili greška, tretiramo kao nevalidan
  }
};

export default ValidateCodeAPI;

